var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('h2',[_c('b-icon',{attrs:{"icon":"apps"}}),_vm._v(" Browse Products")],1),_c('products-table',{attrs:{"category":_vm.category}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }